import { ApplicationStatusId, ApplicationStatus } from "@ploy-lib/types";
import { getIn } from "@ploy-lib/core";
import { decomposeColor } from "@material-ui/core";
export const defaultStatusColorOptions = {
    NotSet: "grey.A200",
    Saved: "info.light",
    Submitted: "success.light",
    Scoring: "warning.light",
    ManualUW: "warning.light",
    AutoApproved: "success.light",
    ManuallyApproved: "success.light",
    ManuallyRejected: "error.light",
    AutoRejected: "error.light",
    Cancelled: "grey.A200",
    Paid: "success.light",
    Transferred: "success.light",
    Replaced: "grey.A200",
    Expired: "grey.A200",
    ApprovedWithConditions: "success.light",
    Prescore: "warning.light",
    Processing: "warning.light",
    Invoiced: "success.light",
    Signed: "info.light",
    InvestPaid: "info.light",
    PartlyPaid: "success.light",
    Offer: "info.light",
    RejectedMissingDocumentation: "error.light",
    Fulfilled: "success.light",
    RedeemProofOfFinancing: "info.light"
};
export function createStatusColors(options = {}, palette) {
    let colors = {};
    for (const status of Object.keys(ApplicationStatus)) {
        const statusId = ApplicationStatusId[status];
        const colorOption = options[status] ?? options[statusId] ?? defaultStatusColorOptions[status];
        let color = getIn(palette, `${colorOption}.main`) ??
            getIn(palette, colorOption) ??
            colorOption;
        try {
            ensureValidColor(color);
        }
        catch (e) {
            if (process.env.NODE_ENV === "development")
                throw e;
            console.warn(e);
            color = palette.grey[200];
        }
        colors[status] = color;
        // Backwards compatabilty: Status color by id
        colors[statusId] = color;
    }
    return colors;
}
// throws if color is in incorrect format ('rgb', 'rgba', 'hsl', 'hsla', or hex)
function ensureValidColor(color) {
    decomposeColor(color);
}
//# sourceMappingURL=statusColors.js.map